import React, { Component } from "react";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import Icon from "../../icon";
import moment from "moment";
import '../../common/custom-form/custom-date-picker.component.css';
import { parseDDMMYYYY } from "../../../utils/helpers.utils";

class DATEPICKER_OR extends Component {
    constructor(props){
        super(props);
        this.datePickerRef = React.createRef();
        this.datePickerClick = null
    }

    handleIconClick = () => {
        if (this.datePickerRef.current) {
            this.datePickerClick();
        }
    };

    render() {
        const { label, subLabel, startDate, selectedDate, isDisable, dateFormat, placeholder, requiredField, minDate, maxDate, isRequired, removeBorder, customClass, dateOnly, additionalClass, displayPlaceholderWhenDisabled } = this.props;
        const { activeDateFormat } = this.props.adminSetting;

        var disableClass = isDisable ? "disabled" : "";       
       
        const CustomInput = React.forwardRef(({ value, onClick, onChange }, ref) => {
            this.datePickerClick = onClick;
            let dateValue = (dateFormat === "MMMM yyyy" && value) ? new Date(value).toLocaleDateString('en-US', { month: 'long', year: 'numeric' }) : value;
            const handleOnBlur=(e)=>{
                let inputValue = e.target.value;

                if (activeDateFormat.Name === "DD/MM/YYYY" && inputValue !== "") {
                    inputValue = parseDDMMYYYY(inputValue);
                }

                if (moment(inputValue, activeDateFormat.CSFormat, true).isValid() || inputValue === "") {
                    onChange(e);
                } else {
                    if (isNaN(new Date(inputValue))) {
                        selectedDate(null);
                    }                   
                }
            }
            return (
                <input type="text" className={`${removeBorder ? 'no-border-input' : 'form-control'}`} value={dateValue} placeholder={displayPlaceholderWhenDisabled ? placeholder : (!isDisable ? placeholder : '')} onBlur={handleOnBlur} onClick={onClick} onChange={onChange} ref={ref} />
            )          
    });

        const onChange = (date) => {
            if (moment(date, activeDateFormat.CSFormat, true).isValid()) {
                let dt = dateOnly && date ? new Date(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`) : date;
                selectedDate(dt);
            } else {
                // Handle invalid date input, e.g., show an error message
                console.error("Invalid date");
                selectedDate(null);
            }
        };


        const handleInput = (e)=>{
            const inputValue = e.target.value;
            if (inputValue === "") {
                selectedDate(null); // If input is empty, clear the date
            }
        }

        return (
            <div className={`date-picker-wrapper ${!label && "align-center"} ${requiredField ? "required":""} ${disableClass} ${additionalClass}`}>
                <div className={`date-picker-container ${customClass}`}>
                    <div className="custom-input-label sub-label-container">
                        <div>{label}</div> 
                        <div>{subLabel}</div> 
                    </div>

                   <div className="date-picker__input-container">
                        <DatePicker
                                ref={this.datePickerRef}
                                selected={startDate} onChange={onChange} placeholderText={placeholder}
                                showMonthYearPicker={dateFormat === "MMMM yyyy" ? true : false}
                                dateFormat={dateFormat === "MMMM yyyy" ? "MMMM yyyy" : activeDateFormat.CSFormat}
                                customInput={<CustomInput onChange={handleInput} />}
                                minDate={minDate}
                                maxDate={maxDate}
                                portalId="datepicker-portal"
                                popperClassName="date-picker__popper"
                            />
                            <Icon
                                customClassName="icon-left"
                                name="calendar-days"
                                size="25px"
                                containerClass="calendar-icon"
                                onClick={this.handleIconClick}
                            />
                   </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => {
        const { adminSetting } = state;

        return {
            adminSetting
        };
    }
)(DATEPICKER_OR)